import { FormLabel, styled } from '@mui/material';

const DynamicFormLabel = styled(FormLabel)`
  &:not(:first-child) {
    margin-top: ${(p) => p.theme.spacing(2)};
  }
`;

export default DynamicFormLabel;
